/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import SecondaryTooltip from '@panel/commons/lib/Tooltip/SecondaryTooltip';
import { isMobileDevice, site } from '@panel/commons/helpers';
import { Step4Module1Operations, Step4Module1Selectors } from '../../../../../ducks/step4Module1';
import { Title, SubTitle, PlanContainer, PlanRow, PlanInfo, TitleContainer } from '../../styles';
import { CustomCheckBox } from '../../../../commons/checkbox';

const countryWithoutFree = site.isEcuador || site.isPanama;

const PlanSelector = React.memo(({ currentPlan, availablePlans, freeAvailable, products }) => {
  const [isPeruFreeRegion, setIsPeruFreeRegion] = useState(false);
  const { selectedOperationTypeId } = useSelector(Step4Module1Selectors.getStep4Module1State);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isMobile = isMobileDevice();
  const operationType = t(`postings.card.operationType.${selectedOperationTypeId}`);
  const tooltipText = `${t(`publisher.step4.module1.toolTip`) + operationType.toLocaleLowerCase()}.`;
  const freemiumValidations = !freeAvailable && availablePlans.length <= 1;

  useEffect(() => {
    if (products.length > 0 && site.isPeru) {
      setIsPeruFreeRegion(products[0].priceListId !== '0R');
    }
  }, [products]);

  return (
    <>
      <TitleContainer>
        <Title data-repa='step4-planSelector-title'>{t('publisher.step4.module1.title')}</Title>
        {!freeAvailable && !countryWithoutFree && !isPeruFreeRegion && (
          <SecondaryTooltip
            type={isMobile ? 'informative' : 'simple'}
            containerLeft='-200.5px'
            arrowRight='26px'
            fixedPosition='top'
          >
            {tooltipText}
          </SecondaryTooltip>
        )}
      </TitleContainer>
      {!currentPlan && availablePlans && availablePlans.length > 0 && !freemiumValidations && (
        <SubTitle data-repa='step4-planSelector-subTitle'>{t('publisher.step4.module1.availablePlans.title')}</SubTitle>
      )}
      {availablePlans.map((p, idx) => {
        const planType = p.publicationPlan.publication_areas[0].publication_type;
        const name = t(`publisher.step4.module1.planName.${planType}`);
        const visibility = t(`publisher.step4.module1.${planType}.visibility`);
        const disponiblesMensaje = `Cantidad ${t('publisher.step4.module1.available.plans.number')}${
          p.available ? p.available : '1'
        }`;

        return (
          <div data-repa={`step4module1-plansArea-plan-${planType}`} key={`row-${planType}-${idx}`}>
            {p.isCurrent && <SubTitle>{t('publisher.step4.module1.currentPlan.title')}</SubTitle>}
            <PlanContainer
              data-repa={`step4module1-plansArea-plan-${planType}-container`}
              isCurrentPlan={p.isCurrent && availablePlans.length > 0}
            >
              <PlanRow
                data-repa={`step4module1-plansArea-plan-${planType}-radio-id-${p.id}`}
                className={planType.toUpperCase()}
                key={planType}
                selected={p.selected}
                plan={planType}
                onClick={() => {
                  dispatch(Step4Module1Operations.selectAvailablePlan(p.publicationPlan.publication_plan_id));
                }}
              >
                <CustomCheckBox
                  isRadioButtom
                  isPlan
                  data-repa={`step4module1-plansArea-plan-${planType}-p-radio`}
                  plan={planType}
                  selected={p.selected}
                  key={`planRadio-${p.id}`}
                >
                  <div>
                    <label
                      data-repa={`step4module1-plansArea-plan-${planType}-radio-label`}
                      htmlFor={`planRadio-${p.id}`}
                    >
                      <input
                        readOnly
                        type='radio'
                        name={`planRadio-${p.id}`}
                        value={`planRadio-${p.id}`}
                        checked={p.selected}
                        data-repa={`step4module1-plansArea-plan-${planType}-radio-input`}
                      />
                      <span data-repa={`step4module1-plansArea-plan-${planType}-radio-label-span`}>{name}</span>
                    </label>
                  </div>
                </CustomCheckBox>
                <PlanInfo
                  data-repa={`step4module1-plansArea-plan-${planType}-info`}
                  orden={2}
                  selected={p.selected}
                  plan={planType}
                >
                  {visibility}
                </PlanInfo>
                <PlanInfo
                  data-repa={`step4module1-plansArea-plan-${planType}-info-description`}
                  orden={0}
                  selected={p.selected}
                >
                  {disponiblesMensaje}
                </PlanInfo>
              </PlanRow>
            </PlanContainer>
            {p.isCurrent && availablePlans.length > 1 && (
              <SubTitle data-repa={`step4module1-plansArea-plan-${planType}-disponibleTitle`}>
                {t('publisher.step4.module1.availablePlans.title')}
              </SubTitle>
            )}
          </div>
        );
      })}
    </>
  );
});

export { PlanSelector };
